import pwd from '../assets/passgen.png'
import text from '../assets/textcon.png'
import news from '../assets/webtoday.png'
import product from '../assets/phys.png'
export const projects=[
    {
        id:1,
        title:'Password Generator',
        img:pwd,
        code:'https://github.com/ShrutiAngane/Password-Generator',
        demo:'https://shrutiangane.github.io/Password-Generator/'
    },
    {
        id:2,
        title:'Live News Website',
        img:news,
        code:'https://github.com/ShrutiAngane/News-WebApp',
        demo:'https://web-today-news.netlify.app/'
    },
    {
        id:3,
        title:'Text Converter and translator',
        img:text,
        code:'https://github.com/ShrutiAngane/TextConverter',
        demo:'https://text-converter-app.netlify.app/'
    },
    {
        id:4,
        title:'Product landing page',
        img:product,
        code:'https://github.com/ShrutiAngane/Product-Landing-Page',
        demo:'https://product-landing-page-web.netlify.app/'
    }
]